// @ts-check

import api from "@core/plugins/api";
import { AccountDTO, AccountPasswordDTO, EtabAdminFolderDTO } from "@core/dto";

const getAccountUrl = () => `/api/et/compte`;
const updateAccountUrl = () => `/api/et/compte`;
const updateAccountPasswordUrl = () => `/api/et/update-password`;
const deleteAccountUrl = () => `/api/et/delete-account`;
const etabAdminFolderUrl = () => `/et/billing/etab-administration`;

export class EtabAccountService {
  static async get() {
    try {
      const response = await api.private.get(getAccountUrl());
      return response && response.data;
    } catch (error) {
      throw error;
    }
  }

  static async update({ account }) {
    try {
      if (account) {
        const dto = new AccountDTO(account);
        const data = dto.prepareUpdateData();
        return api.private.post(updateAccountUrl(), data);
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }

  static async updatePassword({ accountPassword }) {
    try {
      if (accountPassword) {
        const dto = new AccountPasswordDTO(accountPassword);
        const data = dto.prepareUpdateData();
        return api.private.post(updateAccountPasswordUrl(), data);
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }

  static async deleteAccount() {
    try {
      return api.private.post(deleteAccountUrl());
    } catch (error) {
      throw error;
    }
  }

  static async getEtabAdminFolderInfos() {
    try {
      const { data } = await api.private.get(etabAdminFolderUrl());
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async updateEtabAdminFolderInfos({ adminFolder }) {
    try {
      if (adminFolder) {
        const dto = new EtabAdminFolderDTO(adminFolder);
        const updateData = dto.prepareUpdateData();
        const { data } = await api.private.put(etabAdminFolderUrl(), updateData);
        return data;
      }
      throw new Error("Data not provided");
    } catch (error) {
      throw error;
    }
  }
}
